import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { ProgressGetter } from '@/store/progress/progress.module';
import { Progress, ProgressAttachment } from '@/store/progress/progress.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectProgressAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    progressId: {
      type: Number
    }
  },
  setup: (props) => {
    const store = useStore();
    const progress = computed<Progress | undefined>(() => store.getters[ProgressGetter.BY_ID](props.progressId));
    const attachments = computed<ProgressAttachment[]>(() => (progress.value) ? progress.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<ProgressAttachment[]>(() => (progress.value) ? progress.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    const attachmentClick = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      attachments,
      images,
      attachmentOffcanvas,
      show,
      hide,
      attachmentClick,
    };
  }
});
